import { render } from "./MediaRemoved.vue?vue&type=template&id=d33aa30e"
import script from "./MediaRemoved.vue?vue&type=script&lang=js"
export * from "./MediaRemoved.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__